<template>
  <div class="page_user--login">
    <div class="login-form">
      <div class="inner-wrap">
        <div class="label">{{ $t("field.users.username") }}</div>
        <el-input class="input-field" :placeholder="`${$t('placeholder.please_input')}${$t('field.users.username')}`" v-model="username" @keyup.enter.native="login" @change="resetError"></el-input>
        <div class="label">{{ $t("field.users.password") }}</div>
        <el-input class="input-field" :placeholder="`${$t('placeholder.please_input')}${$t('field.users.password')}`" v-model="password" show-password @keyup.enter.native="login" @change="resetError"></el-input>
        <div class="message">{{ error }}</div>
        <div class="action-btn">
          <el-button type="primary" @click="login" :loading="load">{{ $t("button.login") }}</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    let vm = this;
    document.addEventListener('keydown', this.auto_input);
  },
  beforeDestroy() {
    document.removeEventListener("keydown", this.auto_input);
  },
  methods: {
    resetError() {
      if(this.error) {
        this.error = "";
      }
    },
    auto_input(event) {
      if (event.which == 27) {
        this.username = "felix";
        this.password = "password";
        this.login();
      }
    },
    login() {
      // break function if login info incomplete
      if(this.username.length == 0 || this.password.length == 0) {
        this.error = "Login information incomplete";
        return;
      }
      this.load = true;
      this.$axios.post("/authenticate", {
        username: this.username,
        password: this.password
      }).then(res=>{
        // perform login if success
        // save login token
        let token = res.headers.authorization;
        console.log(token);
        console.log(res.data.response.refreshToken);
        localStorage.lt = token;
        localStorage.refreshToken = res.data.response.refreshToken;
        this.$axios.defaults.headers.common["Authorization"] = token;
        console.log(this.$axios.defaults.headers.common);
        this.$store.dispatch("user/fetchPermissions").then(res=>{
          this.$store.commit("status/setReady", true);
        });
        // go to home page
        this.go("");
      }).catch(err=>{
        console.log(err.response);
        if(typeof err.response == "undefined") {
          this.error = this.$t("message.network_error");
        }else if(err.response.status == 401) {
          this.error = this.$t("message.login_failed");
        }else if(err.response.status == 500) {
          this.error = this.$t("message.server_error");
        } 
      }).then(()=>{
        this.load = false;
      });
    }
  },
  computed: {

  },
  data() {
    return {
      username: "",
      password: "",
      error: "",
      load: false
    }
  }
}
</script>

<style lang="scss">
.page_user--login{
  // background: #172145;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  .login-form{
    width: 500px;
    height: 250px;
    background: #f6f6f6;
    border: 1px solid  var(--layout-border-color);
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 5px;
    .inner-wrap{
      width: 400px;
      .label{
        font-size: 14px;
        margin-bottom: 5px;
      }
    }
    .input-field{
      margin-bottom: 15px;
    }
    .message{
      color: red;
      font-size: small;
    }
    .action-btn{
      display: flex;
      justify-content: flex-end;

    }
  }
}
</style>